import { render } from "./officeOperatePart.vue?vue&type=template&id=18a4309a&scoped=true"
import script from "./officeOperatePart.vue?vue&type=script&lang=js"
export * from "./officeOperatePart.vue?vue&type=script&lang=js"

import "./officeOperatePart.vue?vue&type=style&index=0&id=18a4309a&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a4309a"]])

export default __exports__